import { DeliveryMethod, PartNumbersQuery, QueryDiagramsQuery } from '@/buyers/_gen/gql'
import { Address, Maybe, Point } from '@/types'
import { DateTime } from 'luxon'

export enum Priority {
  HIGH = 3,
  MEDIUM = 2,
  LOW = 1,
}

// TODO: remove thyis type
export enum SourcingType {
  VENDORS,
  GF_NETWORK,
}

export type Filters = {
  search: string
  location: Maybe<Point>
  brands: string[]
}

export type Urgency = { priority: Priority; machineDown: boolean; neededByDate: DateTime }

export type JobQuantity = {
  jobId: string
  quantity: number
}

export type CreateRequestState = {
  billingCompanyId?: Maybe<string>
  workOrderNumber?: string
  // The Clue picker writes both: workOrderNumber holds the human WO number
  // (for display / persisted on the RFQ), externalWorkOrderId holds Clue's
  // internal id (for the integration's write-back jobs).
  externalWorkOrderId?: Maybe<string>
  machineOrgId?: Maybe<string>
  machineInvolved?: boolean
  urgency?: { priority: Priority; machineDown: boolean; neededByDate: DateTime }
  parts?: {
    partNumber: Maybe<string>
    description: Maybe<string>
    quantity: number
    rfqQuantity?: Maybe<number>
    externalId: Maybe<string>
    taskNumber: Maybe<string>
    suggestion: Maybe<boolean>
    pictures: string[]
    jobQuantities: {
      jobId: string
      quantity: number
    }[]
    costCodeId: Maybe<string>
    phaseCodeId: Maybe<string>
  }[]
  comments?: string

  nearbyReferencePoint?: Point
  locationId?: string
  locationGroupId?: string
  shippingAddress?: Address

  dealerLocationIds: string[]
  vendors: {
    vendorId: string
    contactIds: string[]
    deliveryMethod: DeliveryMethod
    accountNumber: string
    fleetioId: number | null
  }[]
  brokerRfqId?: Maybe<string>

  broadcastToNetwork: boolean
  quickOrder?: boolean

  tutorial: boolean

  // Approve wizard only: this state has been seeded from the server RFQ, so a
  // later mount must not seed again over the user's edits. Meaningful because
  // the approve wizard's persisted state is keyed per rfqId.
  seeded?: boolean
}

export type PartialRequestUpdate = {
  request: CreateRequestState
  updateRequest: (changes: Partial<CreateRequestState>) => void
}

export type VendorSelectionType = 'limited' | 'full' | 'disabled'

export type Diagram = NonNullable<
  NonNullable<PartNumbersQuery['partNumbers']>[number]
>['diagrams'][number]

export type DiagramOutput = NonNullable<QueryDiagramsQuery['queryDiagrams']>
